export default class MemberEfileJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  summary(profileId) {
    return this.axiosIns.get(`${this.jwtConfig.main.memberProfilesEndpoint}/${profileId}/efile`)
  }

  documents(profileId, params) {
    return this.axiosIns.get(`${this.jwtConfig.main.memberProfilesEndpoint}/${profileId}/efile/documents`, { params })
  }

  // single-use link from the file provider, valid for about 60 seconds
  link(profileId, docId, payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.memberProfilesEndpoint}/${profileId}/efile/documents/${docId}/link`, payload)
  }

  uploadLimits(profileId) {
    return this.axiosIns.get(`${this.jwtConfig.main.memberProfilesEndpoint}/${profileId}/efile/upload-limits`)
  }

  // asks the file provider (through PAC) for an upload slot; the file itself goes straight to the slot
  requestUpload(profileId, payload) {
    return this.axiosIns.post(`${this.jwtConfig.main.memberProfilesEndpoint}/${profileId}/efile/uploads`, payload)
  }

  /* P21: the signed-in person's own file */
  myDocuments(params) {
    return this.axiosIns.get('/me/efile/documents', { params })
  }

  myLink(docId) {
    return this.axiosIns.post(`/me/efile/documents/${docId}/link`, {})
  }

  myAccessLog(params) {
    return this.axiosIns.get('/me/efile/access-log', { params })
  }

  requestCorrection(payload) {
    return this.axiosIns.post('/me/efile/corrections', payload)
  }

  // profile list indicators, answered from PAC's own cache
  indicators(ids) {
    return this.axiosIns.post(`${this.jwtConfig.main.memberProfilesEndpoint}/efile/indicators`, { ids })
  }
}
